<!-- tabla-productos.component.html -->
<!-- Tabla -->
<div class="table-responsive shadow-sm rounded-3 overflow-hidden">
    <table class="table table-hover align-middle mb-0">
        <thead class="table-success">
            <tr>
                <th>
                    Tipo producto
                    <app-icono-filtro
                        tipo="select"
                        [opciones]="categoriasProductos"
                        (filtrar)="
                            onFiltro('tipoProducto', $event)
                        "></app-icono-filtro>
                </th>
                <th>
                    Número registro ICA
                    <app-icono-filtro
                        tipo="input"
                        (filtrar)="
                            onFiltro('numeroRegistroIca', $event)
                        "></app-icono-filtro>
                </th>
                <th>
                    Nombre comercial
                    <app-icono-filtro
                        tipo="input"
                        (filtrar)="
                            onFiltro('nombreComercial', $event)
                        "></app-icono-filtro>
                </th>
                <th>
                    Presentación
                    <app-icono-filtro
                        tipo="input"
                        (filtrar)="
                            onFiltro('empaque', $event)
                        "></app-icono-filtro>
                </th>
                <th>
                    Estado
                    <app-icono-filtro
                        tipo="select"
                        [opciones]="estados"
                        (filtrar)="
                            onFiltro('estado', $event)
                        "></app-icono-filtro>
                </th>
                <th class="text-center">Acción</th>
            </tr>
        </thead>
        <tbody *ngIf="presentaciones.length > 0">
            <tr
                *ngFor="let presentacion of presentaciones"
                class="animate__animated animate__fadeIn">
                <td>
                    {{
                        presentacion.productoComercializador?.tipoProducto
                            .nombre
                    }}
                </td>
                <td>
                    {{
                        presentacion.productoComercializador?.numeroRegistroIca
                    }}
                </td>
                <td class="fw-semibold">
                    {{ presentacion.productoComercializador?.nombreComercial }}
                </td>
                <td>{{ getPresentacion(presentacion) }}</td>
                <td>
                    <span
                        class="badge text-dark border-none rounded-3 px-3 py-2"
                        [ngClass]="{
                            'bg-success-subtle':
                                presentacion.registroProducto.estado ===
                                'activo',
                            'bg-danger-subtle':
                                presentacion.registroProducto.estado ===
                                'inactivo',
                        }">
                        {{ presentacion.registroProducto.estado | titlecase }}
                    </span>
                </td>
                <td class="text-center">
                    <button
                        class="btn btn-sm d-flex align-items-center justify-content-center"
                        (click)="onCambiarEstado(presentacion)"
                        [ngClass]="{
                            'btn-outline-warning bg-warning text-light':
                                presentacion.registroProducto.estado ===
                                'activo',
                            'btn-outline-success bg-success':
                                presentacion.registroProducto.estado ===
                                'inactivo',
                        }">
                        <i
                            [ngClass]="{
                                'bi bi-x-circle me-1':
                                    presentacion.registroProducto.estado ===
                                    'activo',
                                'bi bi-check-circle me-1':
                                    presentacion.registroProducto.estado ===
                                    'inactivo',
                            }"></i>
                        {{
                            presentacion.registroProducto?.estado === 'activo'
                                ? 'Inactivar'
                                : 'Activar'
                        }}
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</div>

<!-- Sin resultados -->
<div *ngIf="presentaciones.length === 0" class="text-center py-5 text-muted">
    <i class="bi bi-inbox fs-1 mb-3"></i>
    <p>No se encontraron presentaciones.</p>
</div>

<!-- Controles inferiores -->
<div
    *ngIf="presentaciones.length > 0"
    class="d-flex justify-content-center mt-4">
    <div class="d-flex align-items-center gap-3">
        <button
            class="btn btn-outline-success btn-sm"
            (click)="onPaginaAnterior()"
            [disabled]="paginaActual === 1">
            ‹ Anterior
        </button>
        <span class="text-secondary small">
            Página
            <strong>{{ paginaActual }}</strong>
            de
            <strong>{{ totalPaginas }}</strong>
        </span>
        <button
            class="btn btn-outline-success btn-sm"
            (click)="onPaginaSiguiente()"
            [disabled]="paginaActual === totalPaginas">
            Siguiente ›
        </button>
    </div>
</div>
